import {
    Container
} from './styles'

export default Container;
